import { IxGenericTreeDemo } from './IxGenericTreeDemo.js';

window.customElements.define('ix-generic-tree-demo', IxGenericTreeDemo);
